export type FeatureSwitches = {
  userSwitches: string[];
  schoolSwitches: string[];
  classroomSwitches: string[];
  communitySwitches: string[];
  classOwnerSwitches: string[];
};

export const SCHOOL_FEATURE_SWITCHES = {
  // Block Building Features
  MONSTERVERSE_ENABLE_ALL_BLOCKS: "monsterverseEnableAllBlocks",

  // Renderering tech
  MONSTERVERSE_USE_UPSCALE_UI: "monsterverseUseUpscaleUIv3",
  MONSTERVERSE_USE_CACHED_MESH2: "monsterverseUseCachedMesh2",

  // Spooky control for both Home and Class islands
  MONSTERVERSE_SPOOKY_SCHOOL: "monsterverseSpookySchool",
  MONSTERVERSE_SPOOKY_COSTUME_STALLS: "monsterverseSpookyCostumeStalls",

  MONSTERVERSE_DOLPHIN_POLO: "monsterverseDolphinPolo",
};

export const USER_FEATURE_SWITCHES = {
  // Stale: remove this and remove the codepaths depending on it (shipped control)
  MONSTERVERSE_USE_SSAO: "monsterverseUseSSAO",

  // Stale: remove this and remove the codepaths depending on it (shipped test)
  MONSTERVERSE_REMOVE_PRELOADED_ASSETS: "monsterverseRemovePreloadedAssets",

  // Stale, but recently bumped from 5% to 50%. Results are leaning towards test
  MONSTERVERSE_SKIP_HTTP_ASSET_CACHE: "monsterverseSkipHttpAssetCache",

  // Stale: remove this and remove the codepaths depending on it (shipped test)
  MONSTERVERSE_NO_PRELOAD_SOUNDS: "monsterverseNoPreloadSounds",

  // Stale: remove this and remove the codepaths depending on it (shipped none)
  MONSTERVERSE_USE_FIXED_RESOLUTION: "monsterverseUseFixedResolution",

  // Stale: remove this and remove the codepaths depending on it (shipped test)
  MONSTERVERSE_USE_BENCHMARK_TIER: "monsterverseUseBenchmarkTier",

  MONSTERVERSE_TERRAIN_EXPERIMENT: "monsterverseTerrainExperiment2",

  MONSTERVERSE_FTUE_WASD_HELPER: "monsterverseFTUEWASDHelper",

  MONSTERVERSE_DEV_USER: "monsterverseDevUser",

  MONSTERVERSE_USE_MSAA: "monsterverseUseMSAA2",

  MONSTERVERSE_USE_MONSTERS_VT: "monsterverseUseMonstersVT2",

  MONSTERVERSE_USE_SAFE_READ_PIXELS: "monsterverseUseSafeReadPixels2",

  MONSTERVERSE_USE_POSITIONAL_AO_PAGING: "monsterverseUsePositionalAOPaging3",

  MONSTERVERSE_GPU_OCCLUSION: "monsterverseGPUOcclusion",

  // FTUE Experimentation - Some players will go to RPC before the Playground
  MONSTERVERSE_FTUE_ROLEPLAY: "monsterverseFTUERoleplay",

  MONSTERVERSE_USE_WEBSOCKET_WORKER: "monsterverseUseWebsocketWorker2",

  MONSTERVERSE_USE_UPLOAD_PBO: "monsterverseUseUploadPBO",
};

export const CLASSROOM_FEATURE_SWITCHES = {
  MONSTERVERSE_DEV_CLASS: "monsterverseDevClass",
};

export const COMMUNITY_FEATURE_SWITCHES = {
  MONSTERVERSE_HOME_UNLIMITED_BLOCKS: "monsterverseHomeUnlimitedBlocks",
  MONSTERVERSE_GUEST_VIP_ISLANDS: "monsterverseGuestVipIslands",

  MONSTERVERSE_PLAYGROUNDS: "monsterversePlaygrounds",

  MONSTERVERSE_FTUE_WASD_HELPER_C: "monsterverseFTUEWASDHelperC",

  MONSTERVERSE_DEV_COMMUNITY: "monsterverseDevCommunity",

  MONSTERVERSE_ACTIVITY_MAP_PREVIEWS: "monsterverseActivityMapPreviews",

  MONSTERVERSE_TOP_DOWN_CAMERA: "monsterverseTopDownCamera",

  MONSTERVERSE_FAST_SERVER_TICK_RATE: "monsterverseFastServerTickRate",

  MONSTERVERSE_HAVEN_V3: "monsterverseHavenV3",

  MONSTERVERSE_SPOOKY_HOME: "monsterverseSpookyHome",

  MONSTERVERSE_VIPS_GET_FTUE: "monsterverseVIPsGetFTUE",

  MONSTERVERSE_FTUE_ROLEPLAY_C: "monsterverseFTUERoleplayC",
};

// Used to support a Mentor Beta program that opts in features based on the owner of a class.
export const CLASS_OWNER_FEATURE_SWITCHES = {};

export const FEATURE_SWITCHES = {
  ...USER_FEATURE_SWITCHES,
  ...SCHOOL_FEATURE_SWITCHES,
  ...CLASSROOM_FEATURE_SWITCHES,
  ...COMMUNITY_FEATURE_SWITCHES,
  ...CLASS_OWNER_FEATURE_SWITCHES,
};

export const FEATURE_SWITCHES_TO_CHECK: FeatureSwitches = {
  userSwitches: Object.values<string>(USER_FEATURE_SWITCHES),
  schoolSwitches: Object.values<string>(SCHOOL_FEATURE_SWITCHES),
  classroomSwitches: Object.values<string>(CLASSROOM_FEATURE_SWITCHES),
  communitySwitches: Object.values<string>(COMMUNITY_FEATURE_SWITCHES),
  classOwnerSwitches: Object.values<string>(CLASS_OWNER_FEATURE_SWITCHES),
};

//Feature switches shown in the editor's Visibility menu
export const EDITOR_FEATURE_SWITCHES = ["spookySeason", "fallSeason", "winterSeason"];
